import { z } from 'zod';

export const YesNo = z.enum(['y', 'n']);

// eslint-disable-next-line no-redeclare
export type YesNo = z.infer<typeof YesNo>;
